import React from 'react';
import { Row, Col } from 'antd';

import PropTypes from 'prop-types';

import './style.scss';
import { startCase } from 'lodash';

function ActivityBar({ actor, desc, date, msgData = {}, dataType = '' }) {
  return (
    <>
      <Row className="order-detail">
        <Col xs={24} className="order-status">
          <Row className="row" gutter={24}>
            <Col xs={9} lg={7}>
              <div className={`actor actor-${actor}`}>{actor}</div>
            </Col>
            <Col xs={15} lg={17}>
              <div className="text">
                <Row gutter={8}>
                  <Col xs={6} lg={0}>
                    {date.slice(0, 10).split('-').join('/')}
                  </Col>
                  <Col xs={24} lg={16}>
                    <p>{desc}</p>
                    {dataType === 'confirm_shipment' &&
                      Object.keys(msgData).map((key) => (
                        <p key={key} className="pd-margin-top-sm">
                          {startCase(key.split('_').join(' '))}:{' '}
                          <strong>{msgData[key]}</strong>
                        </p>
                      ))}
                    {dataType === 'update_bank' && (
                      <>
                        <p>
                          <strong>{`${msgData.bank_name} - ${msgData.account_number}`}</strong>{' '}
                          <br />
                          <strong>{`${msgData.account_holder}`}</strong>
                        </p>
                      </>
                    )}
                    {dataType === 'create_return' && (
                      <>
                        <p>
                          Description:
                          <br />
                          {`${msgData.description}`}
                        </p>
                      </>
                    )}
                    {dataType === 'reject_return' && (
                      <>
                        <p>{`${msgData.message}`}</p>
                      </>
                    )}
                  </Col>
                  <Col xs={0} lg={6} offset={1} className="gray-text">
                    {date.slice(0, 10).split('-').join('/')}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

ActivityBar.propTypes = {
  actor: PropTypes.any,
  desc: PropTypes.any,
  date: PropTypes.any,
  msgData: PropTypes.any,
  dataType: PropTypes.any,
};

export default ActivityBar;
